// extracted by mini-css-extract-plugin
export default {"RightPanelWrap":"Panel_RightPanelWrap__rm5-m","Closed":"Panel_Closed__24kLa"};